import { render, staticRenderFns } from "./BusinessList.vue?vue&type=template&id=ea34634e&scoped=true&"
import script from "./BusinessList.vue?vue&type=script&lang=js&"
export * from "./BusinessList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/modules/_business-list.scss?vue&type=style&index=0&id=ea34634e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea34634e",
  null
  
)

export default component.exports